// src/landings/components/resources/ResourceNotFound.tsx

import { Link } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";

interface ResourceNotFoundProps {
  type?: "category" | "article";
}

function ResourceNotFound({ type = "category" }: ResourceNotFoundProps) {
  return (
    <div className="min-h-screen relative">
      {/* Background */}
      <div className="fixed inset-0 w-full h-full overflow-hidden z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-white via-[#fff5eb] to-[#f9f6f4]"></div>
        
        {/* Grid pattern background */}
        <svg className="absolute inset-0 w-full h-full opacity-[0.07]" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M0 10 L40 10" stroke="#946e5d" strokeWidth="0.5" fill="none" />
              <path d="M0 20 L40 20" stroke="#946e5d" strokeWidth="0.5" fill="none" />
              <path d="M0 30 L40 30" stroke="#946e5d" strokeWidth="0.5" fill="none" />
              <path d="M10 0 L10 40" stroke="#946e5d" strokeWidth="0.5" fill="none" />
              <path d="M20 0 L20 40" stroke="#946e5d" strokeWidth="0.5" fill="none" />
              <path d="M30 0 L30 40" stroke="#946e5d" strokeWidth="0.5" fill="none" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>
      
      <div className="relative z-10">
        <Header />
        
        <main className="min-h-[70vh] flex items-center justify-center p-4">
          <div className="max-w-md w-full text-center">
            <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-[#fff5eb] flex items-center justify-center text-[#ff8c42]">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z" />
              </svg>
            </div>
            
            <h1 className="text-3xl font-bold mb-4 text-[#694e42]">
              {type === "category" ? "Category Not Found" : "Article Not Found"}
            </h1>
            
            <p className="text-[#8a7266] mb-8">
              {type === "category" 
                ? "We couldn't find the resource category you're looking for." 
                : "We couldn't find the specific article you're looking for."}
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/resources"
                className="px-6 py-3 bg-[#ff8c42] text-white rounded-md font-medium"
              >
                Browse All Resources
              </Link>
              
              <Link
                to="/"
                className="px-6 py-3 border border-[#694e42] text-[#694e42] rounded-md font-medium"
              >
                Back to Home
              </Link>
            </div>
          </div>
        </main>
        
        <Footer />
      </div>
    </div>
  );
}

export default ResourceNotFound;